import React, { useLayoutEffect, useRef } from 'react';
import { StyleSheet, Text, View, TouchableOpacity, Dimensions, Animated, Easing } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from '../../../Utils/responsive';
import "../../../App.scss";
const actualWidth = Dimensions.get("screen").width;
const Index = (props) => {
  const introAnimation = useRef(new Animated.Value(actualWidth)).current;
  useLayoutEffect(() => {
    Animated.timing(introAnimation, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false,
      easing: Easing.linear,
    }).start();
  }, []);

  const goBack = () => {
    props.setInfopage((prev) => !prev);
    props.setModuleIndex((moduleIndex) => moduleIndex - 1);
    props.resultContext.resetPreviousModuleResult(props.moduleObject.moduleid);
  };

  return (
    <Animated.View
      style={[styles.content, { transform: [{ translateX: introAnimation }] }]}
    >
      <Text style={styles.heading}>
        {
          props.moduleObject.questions[props.moduleIndex - 1].answers[
            props.metaindex
          ].metadata.resultlabel
        }
      </Text>
      <Text style={styles.customText}>
        {
          props.moduleObject.questions[props.moduleIndex - 1].answers[
            props.metaindex
          ].metadata.confirmationtext
        }
      </Text>
      <View style={styles.line} />
      <TouchableOpacity
        style={styles.button}
        onPress={() => {
          props.pageTwo();
          props.pageThree();
        }}
      >
        <Text style={styles.buttontext}>
          {
            props.moduleObject.questions[props.moduleIndex - 1].answers[
              props.metaindex
            ].metadata.buttontext
          }
        </Text>
      </TouchableOpacity>
      <TouchableOpacity style={styles.goBack} onPress={() => goBack()}>
        <Text style={styles.goBackText}>go back</Text>
      </TouchableOpacity>
    </Animated.View>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },

  customText: {
    position: "relative",
    width: "75%",
    fontSize: "var(--module-detail-font-size)",
    textAlign: "center",
    color: "var(--text-color-alternate)",
    marginBottom: 28,
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--module-detail-letter-spacing)",
  },
  button: {
    backgroundColor: "var(--button-background-color-default)",
    justifyContent: "center",
    borderRadius: 2,
    elevation: 2,
    marginBottom: 28,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 2,
  },
  buttontext: {
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: "var(--button-font-size)",
    textAlign: "center",
    letterSpacing: "var(--button-letter-spacing)",
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
    paddingLeft: "var(--button-padding-left)",
    paddingRight: "var(--button-padding-right)",
    paddingTop: "var(--button-padding-top)",
    paddingBottom: "var(--button-padding-bottom)",
  },
  line: {
    width: "75%",
    maxWidth: 660,
    height: 1,
    backgroundColor: "#d4d4d4",
    marginBottom: hp("4%"),
  },
  heading: {
    fontSize: actualWidth > 1000 ? 48 : actualWidth > 400 ? 32 : 16,
    textAlign: "center",
    color: "var(--text-color-default)",
    marginBottom: hp("3%"),
    fontWeight: "var(--font-weight-light)",
    letterSpacing: actualWidth > 1000 ? 4.8 : actualWidth > 400 ? 3.2 : 1.6,
  },
  goBack: {
    backgroundColor: "transparent",
    width: 118,
    height: 48,
    marginBottom: hp("3%"),
    justifyContent: "center",
  },
  goBackText: {
    color: "var(--text-color-default)",
    fontWeight: "var(--font-weight-bold)",
    fontSize: actualWidth > 400 ? 16 : 12,
    textAlign: "center",
    letterSpacing: actualWidth > 400 ? 1.6 : 1.2,
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
  },
});